<template>




    <div class="tCenteredArea_Easy">
        <div id="tReels_Easy" class="">
            <div id="manage_Easy">
                <div class="manage_header">
                    <h4>{{ $t('posts.manage') }}</h4> 
                    <Button :label="$t('posts.add')" icon="pi pi-plus" size="small" severity="contrast" @click="openManageReels()" />
                </div>
            </div>

            <div id="my-reels-container_Easy">

                <Accordion :value="[]" multiple>
                    <AccordionPanel v-for="post in my_reels" :key="post.id" :value="post.id.toString()">
                        <AccordionHeader>
                            <div v-html="postHeader(post)"></div>
                        </AccordionHeader>
                        <AccordionContent>
                            <div class="post-details">
                                <p><strong>{{ $t('posts.views') }}:</strong> {{ post.views }}</p>
                                <p><strong>{{ $t('posts.likes') }}:</strong> {{ post.likes }}</p>
                                <p><strong>{{ $t('posts.created_at') }}:</strong> {{ formatDate(post.created_at) }}</p>

                                <!-- Content Tablosu -->
                                <DataTable :value="post.contents">
                                    <Column field="url" header="Content">
                                        <template #body="{ data }">
                                            <img v-if="data.isVideo" width="100" :src="data.preview_url" />
                                            <img v-else width="100" :src="data.url" />
                                        </template>
                                    </Column>
                                    <Column field="tokens" header="Tokens" />
                                    <Column field="total_sales" header="Total Sales" />
                                    <Column field="type" header="Type" />
                                    <Column field="isVideo" header="Is Video" :body="isVideoBody" />
                                </DataTable>

                                <!-- Edit Post Content Button -->
                                <Button :label="$t('posts.edit')" icon="pi pi-pencil" class="p-button-secondary mt-3"
                                    @click="editPost(post)" />
                            </div>
                        </AccordionContent>
                    </AccordionPanel>
                </Accordion>




                <!-- Dialog for Editing Post -->
                <Dialog v-if="selectedPost" header="Edit Post" :visible="editDialogVisible" modal
                    @update:visible="editDialogVisible = $event">
                    <Editor v-model="selectedPost.post_messages" style="height:200px" />
                    <Button :label="$t('buttons.save')" class="p-button-success mt-2" @click="savePost" />
                </Dialog>
            </div>
        </div>
    </div>




    <Dialog v-model:visible="visibleModal" modal header="New Post">
        <div class="custom-file-uploader">
            <FileUpload name="demo[]" multiple accept="image/*,video/*" customUpload :auto="true"
                chooseLabel="Choose Image or Video" :onSelect="onFileSelect" :onRemove="onFileRemove" mode="basic"
                class="p-button-contrast" :chooseButtonProps="chooseButtonProps" />

            <!-- File Preview with Price, Sorting and Previews -->
            <div v-if="files.length > 0" class="file-list">
                <div v-for="(file, index) in files" :key="index" class="file-item">
                    <!-- File Preview -->
                    <div class="file-preview">
                        <img v-if="file.type.startsWith('image/')" :src="file.previewUrl" alt="Image preview"
                            class="image-preview" />
                        <video v-if="file.type.startsWith('video/')" controls class="video-preview">
                            <source :src="file.previewUrl" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>

                    <div class="price-input">
                        <label :for="'price-' + index">Tokens</label>
                        <InputNumber v-model="file.price" :id="'token-' + index" :min="0" :max="500"
                            style="width: 50px;" class="custom-input-number" />
                    </div>

                    <div class="button-group">
                        <Button icon="pi pi-arrow-up" class="p-button-info-alt" @click="moveUp(index)"
                            severity="contrast" text rounded :disabled="index === 0" />
                        <Button icon="pi pi-arrow-down" class="p-button-info-alt" @click="moveDown(index)"
                            severity="contrast" text rounded :disabled="index === files.length - 1" />
                        <Button icon="pi pi-times" class="p-button-info-alt" @click="remove(index)" severity="danger"
                            text rounded />
                    </div>
                </div>
            </div>
            <div>
                <label>Content</label>
                <Editor v-model="value" editorStyle="height: 120px">
                    <template v-slot:toolbar>
                        <span class="ql-formats">
                            <button v-tooltip.bottom="'Bold'" class="ql-bold"></button>
                            <button v-tooltip.bottom="'Italic'" class="ql-italic"></button>
                            <button v-tooltip.bottom="'Underline'" class="ql-underline"></button>
                        </span>
                    </template>
                </Editor>
            </div>

            <!-- Submit Button -->
            <Button :label="$t('posts.publish_post')" icon="pi pi-upload" severity="contrast" @click="submitFiles"
                class="post-button mt-4" />
        </div>
    </Dialog>






    <Toast />

</template>

<script>

import axios from 'axios';

export default {
    data() {
        return {
            my_reels: [],
            files: [],
            value: '',
            visibleModal: false,
            chooseButtonProps: {
                severity: 'contrast',
            },
            uploadPercentage: 0,
            selectedPost: null,
            editDialogVisible: false,
        };
    },
    methods: {
        getWithoutHtml(text) {
            return text.replace(/<[^>]+>/g, '');
        },
        addImageToPopup(event) {
            const data = event.data;
            const realFileName = data.url.split('/').pop();



            if (data.type === 'selected-iframe-image') {
                const selectedFiles = [{
                    name: realFileName,
                    type: 'image/png',
                    size: 0,
                    price: 0, // Initial price as null
                    file: null,
                    previewUrl: data.url
                }]

                this.files = [...this.files, ...selectedFiles];

            }
        },
        onFileSelect(event) {
            const selectedFiles = event.files.map(file => {
                const previewUrl = URL.createObjectURL(file); // Generate preview URL
                return {
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    price: 0, // Initial price as null
                    file,
                    previewUrl // Add preview URL for image/video preview
                };
            });
            this.files = [...this.files, ...selectedFiles];
        },
        onFileRemove(event) {
            this.files = this.files.filter(f => f.name !== event.file.name);
        },
        moveUp(index) {
            if (index > 0) {
                const temp = this.files[index - 1];
                this.files[index - 1] = this.files[index];
                this.files[index] = temp;
            }
        },
        moveDown(index) {
            if (index < this.files.length - 1) {
                const temp = this.files[index + 1];
                this.files[index + 1] = this.files[index];
                this.files[index] = temp;
            }
        },
        remove(index) {
            this.files.splice(index, 1);
        },
        async submitFiles() {


            if (this.value === '') {
                this.$toast.add({ severity: 'warn', summary: 'Information', detail: 'Content cannot be empty', life: 3000 });
                return;
            }

            const count_files_with_file = this.files.filter(file => file.file).length;
            const count_files_without_file = this.files.filter(file => !file.file).length;

            if (count_files_with_file > 0 && count_files_without_file > 0) {
                this.$toast.add({ severity: 'warn', summary: 'Information', detail: 'Please select either all files or none', life: 3000 });
                return;
            }


            if (count_files_with_file > 0 || count_files_without_file == 0) {

                const formData = new FormData();
                this.files.forEach(file => {
                    formData.append('files', file.file);
                });
                this.files.forEach(file => {
                    formData.append('tokens', file.price);
                });
                formData.append('content', this.value);
                try {
                    const response = await axios.post(this.$socket_url + '/uploadReel', formData, {
                        headers: {
                            'Authorization': this.$socket.authKeyUnique.auth,
                            'User_ID': this.$socket.authKeyUnique.user_id,
                            'Content-Type': 'multipart/form-data'

                        },
                        onUploadProgress: (progressEvent) => {
                            this.uploadPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        }
                    });

                    if (response.data.status) {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Reel uploaded successfully', life: 3000 });
                        this.files = [];
                        this.value = '';
                        this.uploadPercentage = 0;
                    } else {
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.error, life: 3000 });
                    }
                } catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Reel upload failed', life: 3000 });
                }
            } else if (count_files_without_file > 0) {

                const postData =
                {
                    content: this.value,
                    files: this.files.map(file => {
                        return {
                            name: file.name,
                            type: file.type,
                            price: file.price
                        }
                    })
                }



                const response = await axios.post(this.$socket_url + '/uploadReelWithoutFile', postData, {
                    headers: {
                        'Authorization': this.$socket.authKeyUnique.auth,
                        'User_ID': this.$socket.authKeyUnique.user_id
                    }
                });
                if (response.data.status) {
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Reel uploaded successfully', life: 3000 });
                    this.files = [];
                    this.value = '';
                    this.uploadPercentage = 0;
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.error, life: 3000 });

                }
            }

        },
        openManageReels() {
            this.visibleModal = true
        },
        loadMore() {
            this.$socket.emit('getMyReels', { limit: 10, offset: this.my_reels.length });
        },
        postHeader(post) {
            const firstImage = post.contents.find(content => !content.isVideo)?.url || post.avatar;
            return `<img src="${firstImage}" alt="Avatar" style="width: 50px; margin-right: 10px;"><div class="post-header">${post.post_messages}</div> `;
        },

        isVideoBody(content) {
            return content.isVideo ? 'Yes' : 'No';
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString();
        },
        editPost(post) {
            this.selectedPost = { ...post }; // Clone post data to edit
            this.editDialogVisible = true;
        },
        savePost() {
            // Save the edited post content
            const postIndex = this.my_reels.findIndex(p => p.id === this.selectedPost.id);
            if (postIndex !== -1) {
                this.my_reels[postIndex].post_messages = this.selectedPost.post_messages;
            }
            this.editDialogVisible = false;
        }

    },
    mounted() {
        this.$socket.emit('getMyReels', { limit: 10, offset: 0 });
        this.$socket.on('my-reels', (data) => {
            if (data && data.length > 0) {
                data.forEach((reel) => {
                    reel.contents = reel.contents.map(file => {
                        return {
                            ...file,
                            token: parseInt(file.tokens),
                            isVideo: file.type,
                            url: this.$socket_url + '/viewReels/' + file.url,
                            preview_url: this.$socket_url + '/previewReels/' + file.url
                        };
                    });
                    this.my_reels.push(reel);
                })
            }
        });

        window.addEventListener('message', this.addImageToPopup);


    },
    unmounted() {
        this.$socket.off('my-reels');
        window.removeEventListener('message', this.addImageToPopup);
    }
};
</script>

<style scoped>
.content-wrapper {
    display: flex;
    flex-direction: column;
}

.custom-input-number {
    width: 50px;
}

.p-button-icon-only {
    width: auto;
}

.manage_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

#manage_Easy {
    display: flex;
    grid-gap: 40px;
    max-width: 742px;
    flex-direction: column;
    margin: auto
}

#my-reels-container_Easy {
    display: flex;
    max-width: 742px;
    flex-direction: column;
    margin: auto
}


.post-button {
    width: 100%;
}

.custom-file-uploader {
    max-width: 400px;
    min-width: 340px;
    margin: auto;
}

.file-list {
    margin-top: 20px;
}

.file-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.file-preview {
    width: 40px;
    height: 40px;
    margin-right: 10px;
}

.image-preview {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 1rem;

}

.video-preview {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 1rem;
}

.price-input {
    display: flex;
    align-items: center;
    margin-left: 10px;
    flex-direction: column;
}

.button-group {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-left: auto;
}
</style>